/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Skriv et eller annet …',
  'fabric.editor.editorAssistiveLabel': 'Hovedinnholdsområde, begynn å skrive for å angi tekst.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Åpne dialogboks for hjelp',
};
